<template>
  <div class="card modal-card-panier modal-card-border">
    <div class="card-content">
      <header>
        <div class="has-text-centered">
          <b-icon
            icon="email"
            size="is-large"
            class="cloud-check"
            type="is-success">
          </b-icon>
        </div>
        <br>
      </header>
      <section>
        <p class="subtitle is-4">L'email a été envoyé à
          <span class="has-text-weight-semibold"
                :key="index" v-for="(to, index) in destinataires">{{ to }}</span>
        </p>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
        <a ref="lienDownload"></a>
        <button class="button is-primary margin-right-10" @click="exporterPdf()">
          <b-icon
            icon="file-pdf-box" class="margin-right-10">
          </b-icon>
          Exporter en PDF
        </button>
        </div>
        <br>
        <div class="has-text-centered">
          <button class="button is-primary button-modal has-text-centered"
                  @click="isComponentConfirmationMail = false">
            Terminer
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import HTTP from '@/api/HTTP';
import gestionErreur from '@/services/general/gestionErreur';

const Panier = createNamespacedHelpers('panier');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'confirmation-mail',
  props: ['url'],
  computed: {
    ...Panier.mapGetters({
      destinataires: 'destinataires',
    }),
    ...Modal.mapGetters({
      getIsComponentConfirmationMail: 'isComponentConfirmationMail',
    }),
    isComponentConfirmationMail: {
      get() {
        return this.getIsComponentConfirmationMail;
      },
      set(value) {
        this.setIsComponentConfirmationMail(value);
      },
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentConfirmationMail: typesModal.SET_IS_COMPONENT_CONFIRMATION_MAIL,
    }),
    exporterPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      HTTP.get(this.url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur('Erreur lors de l\'export du PDF de l\'opportunité', e);
        loadingComponent.close();
        throw e;
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/envoyerOpportunite/confirmationMail.vue